import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { CoreDisputeType } from "@handshake/core-types";

/** Aces Programme site, linked from the ID-only defect assessment step (HAN-633). */
export const ACES_PROGRAMME_URL = "https://agcare.com.sg/";

/** Panel key for the ID-only "Independent Defect Assessment (Aces Programme)" step (HAN-633). */
export const DEFECT_ASSESSMENT_PANEL_ID = "defect_assessment";

export type CoreDisputeGuidePanelId = CoreDisputeType | typeof DEFECT_ASSESSMENT_PANEL_ID;

export interface CoreDisputeGuidePanel {
  id: CoreDisputeGuidePanelId;
  name: string;
}

const STEP_TITLES: { id: CoreDisputeGuidePanelId; title: string; idOnly?: boolean }[] = [
  { id: CoreDisputeType.INITIAL_ATTEMPT, title: "Initial Resolution Attempts (Strongly Recommended)" },
  { id: DEFECT_ASSESSMENT_PANEL_ID, title: "Independent Defect Assessment (Aces Programme)", idOnly: true },
  { id: CoreDisputeType.MEDIATION, title: "Mediation (Third-Party Assisted Resolution)" },
  { id: CoreDisputeType.ARBITRATION, title: "Arbitration (Binding Third-Party Decision)" },
  { id: CoreDisputeType.LITIGATION, title: "Litigation" },
];

/**
 * Numbered guide steps. Interior Design projects get the Aces Programme step as Step 2 and the
 * rest shift down by one; everyone else keeps the original 1–4 numbering.
 */
export function buildDisputeGuidePanels(showDefectAssessment: boolean): CoreDisputeGuidePanel[] {
  return STEP_TITLES.filter((step) => !step.idOnly || showDefectAssessment).map((step, index) => ({
    id: step.id,
    name: `Step ${index + 1}: ${step.title}`,
  }));
}

@Component({
  selector: "app-core-dispute-resolution-guide",
  standalone: true,
  imports: [CommonModule, NzCollapseModule],
  templateUrl: "./core-dispute-resolution-guide.component.html",
})
export class CoreDisputeResolutionGuideComponent {
  /** When false (ID structure projects), hide CaseTrust mediation naming/links. */
  @Input() showCaseTrustBrand = true;

  /** Interior Design companies and their clients only: show the Aces Programme defect assessment step (HAN-633). */
  @Input() set showDefectAssessment(value: boolean | null | undefined) {
    this.panels = buildDisputeGuidePanels(!!value);
  }

  readonly DisputeType = CoreDisputeType;
  readonly DEFECT_ASSESSMENT_PANEL_ID = DEFECT_ASSESSMENT_PANEL_ID;
  readonly acesProgrammeUrl = ACES_PROGRAMME_URL;
  panels: CoreDisputeGuidePanel[] = buildDisputeGuidePanels(false);
}
